import React from 'react';

interface SubscriptionGateProps {
  children: React.ReactNode;
}

const SubscriptionGate: React.FC<SubscriptionGateProps> = ({ children }) => {
  return <>{children}</>;
};

export default SubscriptionGate;
